import { useEnvironmentInterface } from "environment-interface";
import type { Command } from "environment-interface/monacoEditor/browser/services/editor/vscode/monaco";
import { DisposableStore } from "vscode/monaco";

import { useVSCodeExtensionInitializedEffect } from "hooks/useVSCodeExtensionInitializedEffect";

export const useRegisterCommands = (
  commands: Command[],
  deps: React.DependencyList = [],
) => {
  const { monacoEditor } = useEnvironmentInterface();

  useVSCodeExtensionInitializedEffect(() => {
    const disposableStore = new DisposableStore();

    monacoEditor.vscodeExtensionApiBarrier.wait().then(() => {
      if (disposableStore.isDisposed) {
        return;
      }

      commands.forEach((command) => {
        disposableStore.add(monacoEditor.registerCommand(command));
      });
    });

    return () => {
      disposableStore.dispose();
    };
  }, deps);
};
